// FAZ-10 / K-25 — defaultStyleJson canlanır: güvenli CSS property whitelist'iyle
// bir component wrapper stiline çevrilir. Faz-9'da `defaultStyleJson` render'da
// SIFIR tüketiciydi (ölü alan); burada güvenli bir alt-küme ile canlandırılır.
//
// BE bu alanı opak tutar (20KB cap dışında valide etmez); tüm güvenlik burada:
//   • yalnız bilinen React CSSProperties anahtarları geçer (bilinmeyen → atılır)
//   • tehlikeli değerler (url(), javascript:, expression(), @import, `<`) reddedilir
//   • yalnız string/number değerler kabul edilir

import type { CSSProperties } from 'react';

/** İzin verilen CSS property'leri (React camelCase; görsel-güvenli alt-küme). */
const SAFE_STYLE_PROPERTIES = new Set<string>([
  'color',
  'backgroundColor',
  'padding',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'margin',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'border',
  'borderColor',
  'borderWidth',
  'borderStyle',
  'borderRadius',
  'fontFamily',
  'fontSize',
  'fontWeight',
  'fontStyle',
  'lineHeight',
  'letterSpacing',
  'textAlign',
  'textTransform',
  'width',
  'minWidth',
  'maxWidth',
  'height',
  'minHeight',
  'maxHeight',
  'display',
  'gap',
  'boxShadow',
  'opacity',
]);

/** Değerlerde asla kabul edilmeyen desenler (CSS enjeksiyon / kaynak yükleme). */
const DANGEROUS_VALUE = /url\s*\(|javascript:|expression\s*\(|@import|<|\/\*|;/i;

/**
 * defaultStyleJson'ı güvenli bir React CSSProperties nesnesine çözer. Geçersiz
 * JSON, dizi, bilinmeyen property ve tehlikeli değerler sessizce düşürülür.
 */
export function parseDefaultStyle(json: string | null | undefined): CSSProperties {
  if (!json || !json.trim()) return {};
  let raw: unknown;
  try {
    raw = JSON.parse(json);
  } catch {
    return {};
  }
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};

  const out: Record<string, string | number> = {};
  for (const [key, value] of Object.entries(raw as Record<string, unknown>)) {
    if (!SAFE_STYLE_PROPERTIES.has(key)) continue;
    if (typeof value === 'number') {
      if (Number.isFinite(value)) out[key] = value;
      continue;
    }
    if (typeof value !== 'string') continue;
    if (DANGEROUS_VALUE.test(value)) continue;
    out[key] = value;
  }
  return out;
}
